import React from 'react';
import { IconClose } from '@noths/polaris-client-ribbons-design-system';
import { useRouter } from 'next/router';

import type {
  FacetOptionWithResetHref,
  FacetWithResetHrefs,
} from 'src/adapters/storeToPageURL/adaptStoreToUIFacetHrefs';
import * as styles from './ActiveFacets.styles';

interface ActiveFacetsProps {
  activeFacets: FacetWithResetHrefs[];
  clearAllHref?: string;
}

export const ActiveFacets = ({ activeFacets, clearAllHref }: ActiveFacetsProps) => {
  const router = useRouter();
  const navigate = (href: string) => router.push(href, undefined, { shallow: true, scroll: false });

  const activeFacetOptions = activeFacets.reduce((acc, facet) => {
    facet.options.forEach((option) => {
      const href = option.href;

      if (option.active && href) {
        acc.push({ facet, option: { ...option, href } });
      }
    });

    return acc;
  }, [] as { facet: FacetWithResetHrefs; option: FacetOptionWithResetHref & { href: string } }[]);

  if (activeFacets.length === 0) {
    return null;
  }

  return (
    <ul css={styles.list}>
      {activeFacetOptions.map(({ facet, option }) => (
        <li key={`${facet.key}-${option.value}`}>
          <button
            aria-label={`Clear the "${option.title}" filter`}
            css={styles.resetFacetButton}
            data-href={option.href}
            onClick={() => {
              navigate(option.href);
            }}
            type="button"
          >
            {option.title} <IconClose color="var(--brand-purple-base)" />
          </button>
        </li>
      ))}
      {clearAllHref && (
        <li>
          <button
            aria-label="Clear all filters"
            css={styles.resetAllButton}
            data-href={clearAllHref}
            onClick={() => {
              navigate(clearAllHref);
            }}
            type="button"
          >
            Clear all
          </button>
        </li>
      )}
    </ul>
  );
};
